import React, { memo } from 'react';
import { useDevice } from '@atc/react-device';
import _get from 'lodash/get';
import { Select } from 'reaxl';

import {
    Button,
    Glyphicon,
} from 'reaxl';

function FilteredResultsControls({
    className,
    filterCount = 0,
    onFilterClick = () => { },
    onSortByChange = () => { },
    optimizelyFilterText = 'Filter',
    showFilter = true,
    sortData = {},
}) {
    const showFilterCount = filterCount && (filterCount > 0) ? ` (${filterCount})` : '';
    const device = useDevice();
    const isXs = _get(device, 'is.xs', false);

    const mobileFilter = (
        <Button
            key="mobileFilterButton"
            onClick={onFilterClick}
            data-cmp="mobileFilterButton"
        >
            <Glyphicon
                glyph="filter"
                className="margin-right-2 text-accent"
                key="filter-glyph"
            />
            {optimizelyFilterText}
            {showFilterCount}
        </Button>
    );

    return (
        <div
            data-cmp="filteredResultsControls"
            className={className}
        >
            <div className="btn-group-lean button-wrapper btn-fill-space">
                {showFilter && isXs && mobileFilter}
                <Select
                    data-cmp="ddp-sorting"
                    className="justify-content-md-end margin-bottom-0"
                    labelProps=""
                    onChange={onSortByChange}
                    {...sortData}
                />
            </div>
        </div>
    );
}

export default memo(FilteredResultsControls);
